<!-- Ported from analytics-design/src/components/FilterBar.tsx.
     SETTE redesign (CLIPPING-598): token-by-token restyle plus one structural change the design
     spec calls for explicitly (Правило Д): "Една лента за контроли, директно на bg-page - без
     Panel" - the outer bar no longer has its own bg-surface/border/shadow box, it's just the
     controls sitting directly on the page, each one a FilterChip-style pill. Interaction model
     (dropdowns, drawer, toasts) is unchanged. -->
<div class="relative w-full" #dropdownRoot>
	<!-- 1. MAIN UNIFIED FILTER BAR ROW -->
	<div class="flex flex-wrap items-center justify-between gap-2.5 text-xs text-ink-muted">
		<div class="flex flex-wrap items-center gap-2 flex-1 min-w-0">
			<!-- Date range + compare -->
			<app-date-range-picker
				[dateRange]="pickerDateRange"
				[compareOption]="pickerCompareOption"
				(dateRangeChange)="onDateRangeChange($event)"
				(compareOptionChange)="onCompareOptionChange($event)">
			</app-date-range-picker>

			<!-- Brand multi-select -->
			<div class="relative">
				<button
					type="button"
					(click)="toggleBrandDropdown()"
					class="flex items-center gap-1.5 border rounded-full px-3 h-8 transition-colors cursor-pointer text-xs"
					[class]="activeDropdown === 'brand'
						? 'border-blue bg-blue-tint text-blue'
						: (currentFilters.brands.length < allBrands.length ? 'border-blue bg-blue-tint text-blue' : 'border-line-strong bg-surface text-ink')">
					<span class="text-ink-subtle font-medium">{{ 'ANALYTICS_FILTER_BAR.BRAND_LABEL' | translate }}</span>
					<span class="font-medium truncate max-w-[170px]">{{ brandButtonLabel }}</span>
					<mat-icon class="!w-3 !h-3 !text-xs shrink-0 transition-transform duration-150" [class.rotate-180]="activeDropdown === 'brand'">expand_more</mat-icon>
				</button>

				@if (activeDropdown === 'brand') {
				<div class="absolute left-0 top-full mt-1 w-64 bg-surface border border-line rounded-xl shadow-pop z-50 p-2.5 text-xs">
					<div class="flex items-center justify-between pb-2 mb-2 border-b border-line">
						<span class="overline-label text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.SELECT_MONITORED_BRANDS' | translate }}</span>
						<div class="flex items-center gap-2 text-[10px]">
							<button type="button" (click)="selectAllBrands()" class="text-blue hover:underline font-medium">{{ 'ANALYTICS_FILTER_BAR.ALL' | translate }}</button>
							<span class="text-ink-subtle">·</span>
							<button type="button" (click)="selectOnlyClient()" class="text-blue hover:underline font-medium">{{ 'ANALYTICS_FILTER_BAR.ONLY_X' | translate: { name: clientBrandLabel } }}</button>
						</div>
					</div>
					<div class="space-y-1">
						@for (brand of allBrands; track brand.id) {
						<div
							(click)="toggleBrand(brand.id)"
							class="flex items-center justify-between px-2 py-1.5 rounded-lg cursor-pointer transition-colors"
							[class]="currentFilters.brands.includes(brand.id) ? 'bg-blue-tint font-medium text-ink' : 'text-ink-muted hover:bg-surface-gray'">
							<div class="flex items-center gap-2">
								<input type="checkbox" [checked]="currentFilters.brands.includes(brand.id)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
								<span class="w-2 h-2 rounded-[3px]" [style.background-color]="brand.color"></span>
								<span>{{ brand.name }}</span>
							</div>
							<span class="text-[10px] text-ink-subtle font-normal">{{ (brand.role === 'client' ? 'ANALYTICS_GLOSSARY.OUR_BRAND' : 'ANALYTICS_GLOSSARY.COMPETITOR') | translate }}</span>
						</div>
						}
					</div>
				</div>
				}
			</div>

			<!-- Filters drawer toggle -->
			<button
				type="button"
				(click)="openDrawer()"
				class="flex items-center gap-1.5 border rounded-full px-3 h-8 transition-colors cursor-pointer text-xs font-medium"
				[class]="activeCount > 0
					? 'bg-blue-tint border-blue text-blue'
					: 'bg-surface border-line-strong text-ink'">
				<mat-icon class="!w-3.5 !h-3.5 !text-sm" [class]="activeCount > 0 ? 'text-blue' : 'text-ink-subtle'">tune</mat-icon>
				<span>{{ activeCount > 0 ? ('ANALYTICS_FILTER_BAR.FILTERS_BUTTON_COUNT' | translate: { count: activeCount }) : ('ANALYTICS_FILTER_BAR.FILTERS_BUTTON' | translate) }}</span>
			</button>
		</div>

		<!-- Save view + Export -->
		<div class="shrink-0 flex items-center gap-2">
			@if (isSaveableScreen) {
			<button
				type="button"
				(click)="openSaveViewModal()"
				class="bg-surface hover:bg-blue-tint text-blue border-[1.5px] border-blue font-medium px-3.5 rounded-full text-xs transition-colors flex items-center gap-1.5 h-8 cursor-pointer">
				<mat-icon class="!w-3.5 !h-3.5 !text-sm">bookmark_add</mat-icon>
				<span>{{ 'ANALYTICS_FILTER_BAR.SAVE_VIEW' | translate }}</span>
			</button>
			}
			<button
				type="button"
				(click)="exportMentions()"
				[disabled]="exportLoading"
				[title]="'ANALYTICS_FILTER_BAR.EXPORT_MENTIONS_TOOLTIP' | translate"
				class="bg-surface hover:bg-blue-tint text-blue border-[1.5px] border-blue font-medium px-2.5 rounded-full text-xs transition-colors flex items-center gap-1 h-8 cursor-pointer disabled:opacity-50">
				<mat-icon class="!w-3.5 !h-3.5 !text-sm">table_view</mat-icon>
				<span>{{ exportLoading ? '...' : ('ANALYTICS_FILTER_BAR.XLS' | translate) }}</span>
			</button>
			<button
				type="button"
				(click)="requestPdfExport()"
				[disabled]="pdfExporting"
				[title]="'ANALYTICS_FILTER_BAR.EXPORT_PDF_TOOLTIP' | translate"
				class="bg-blue hover:bg-blue-hover text-on-blue font-medium px-3.5 rounded-full text-xs transition-colors flex items-center gap-1.5 h-8 cursor-pointer disabled:opacity-50">
				<mat-icon class="!w-3.5 !h-3.5 !text-sm">picture_as_pdf</mat-icon>
				<span>{{ pdfExporting ? ('ANALYTICS_FILTER_BAR.GENERATING_PDF' | translate) : ('ANALYTICS_FILTER_BAR.EXPORT_PDF' | translate) }}</span>
			</button>
		</div>
	</div>

	<!-- Save View modal -->
	@if (saveViewModalOpen) {
	<div class="fixed inset-0 z-50 bg-ink/60 backdrop-blur-xs flex items-center justify-center p-4">
		<div class="bg-surface rounded-2xl shadow-pop border border-line w-full max-w-md overflow-hidden text-xs">
			<div class="px-5 py-4 border-b border-line flex items-center justify-between bg-page">
				<h3 class="item-title text-ink">{{ 'ANALYTICS_FILTER_BAR.SAVE_CURRENT_VIEW' | translate }}</h3>
				<button type="button" (click)="closeSaveViewModal()" class="w-8 h-8 rounded-full hover:bg-surface-gray text-ink-subtle hover:text-ink flex items-center justify-center transition-colors cursor-pointer">
					<mat-icon class="!w-4 !h-4 !text-base">close</mat-icon>
				</button>
			</div>

			<form (ngSubmit)="submitSaveView()" class="p-5 space-y-4">
				<div>
					<label class="block text-xs font-medium text-ink mb-1">{{ 'ANALYTICS_FILTER_BAR.VIEW_NAME_LABEL' | translate }} <span class="text-negative">*</span></label>
					<input
						type="text"
						required
						cdkFocusInitial
						[placeholder]="'ANALYTICS_FILTER_BAR.VIEW_NAME_PLACEHOLDER' | translate"
						[(ngModel)]="saveViewName"
						name="saveViewName"
						class="w-full bg-surface border border-line-strong rounded-xl px-3 py-2 text-xs text-ink focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2 font-medium" />
				</div>

				<div>
					<label class="block text-xs font-medium text-ink mb-1.5">{{ 'ANALYTICS_FILTER_BAR.PERIOD_LABEL' | translate }}</label>
					<div class="grid grid-cols-2 gap-3">
						<label
							class="flex items-center gap-2 p-2.5 rounded-xl border cursor-pointer"
							[class]="saveViewPeriodType === 'FIXED' ? 'border-blue bg-blue-tint' : 'border-line bg-surface hover:bg-surface-gray'">
							<input type="radio" name="period_type" [checked]="saveViewPeriodType === 'FIXED'" (change)="saveViewPeriodType = 'FIXED'" class="accent-blue" />
							<div>
								<span class="text-xs font-medium text-ink block">{{ 'ANALYTICS_FILTER_BAR.FIXED' | translate }}</span>
								<span class="text-[10px] text-ink-subtle">{{ currentFilters.dateRange }}</span>
							</div>
						</label>
						<label
							class="flex items-center gap-2 p-2.5 rounded-xl border"
							[class]="!canSaveRelativePeriod ? 'border-line bg-page opacity-50 cursor-not-allowed' : (saveViewPeriodType === 'RELATIVE' ? 'border-blue bg-blue-tint cursor-pointer' : 'border-line bg-surface hover:bg-surface-gray cursor-pointer')">
							<input
								type="radio"
								name="period_type"
								[disabled]="!canSaveRelativePeriod"
								[checked]="saveViewPeriodType === 'RELATIVE'"
								(change)="saveViewPeriodType = 'RELATIVE'"
								class="accent-blue" />
							<div>
								<span class="text-xs font-medium text-ink block">{{ 'ANALYTICS_FILTER_BAR.RELATIVE' | translate }}</span>
								<span class="text-[10px] text-ink-subtle">{{ canSaveRelativePeriod ? ('ANALYTICS_FILTER_BAR.ALWAYS_FROM_TODAY' | translate: { range: currentFilters.dateRange }) : ('ANALYTICS_FILTER_BAR.PICK_PRESET_FIRST' | translate) }}</span>
							</div>
						</label>
					</div>
				</div>

				<div class="pt-3 border-t border-line flex items-center justify-end gap-2">
					<button type="button" (click)="closeSaveViewModal()" class="h-10 px-[18px] border border-line-strong hover:bg-surface-gray text-ink font-medium rounded-full transition-colors cursor-pointer">
						{{ 'BUTTON.CANCEL' | translate }}
					</button>
					<button type="submit" [disabled]="!saveViewName.trim() || saveViewLoading" class="h-10 px-[18px] bg-blue hover:bg-blue-hover text-on-blue font-medium rounded-full transition-colors cursor-pointer disabled:opacity-50">
						{{ saveViewLoading ? ('ANALYTICS_FILTER_BAR.SAVING' | translate) : ('ANALYTICS_FILTER_BAR.SAVE_VIEW' | translate) }}
					</button>
				</div>
			</form>
		</div>
	</div>
	}

	@if (toastMessage) {
	<div class="fixed bottom-5 right-5 z-50 bg-ink text-white px-4 py-3 rounded-[14px] shadow-toast text-xs font-medium flex items-center gap-2">
		<mat-icon class="!w-4 !h-4 !text-base text-positive-soft">check_circle</mat-icon>
		<span>{{ toastMessage }}</span>
	</div>
	}

	<!-- 2. FILTERS DRAWER (slides in from the right) -->
	@if (drawerOpen) {
	<div class="fixed inset-0 z-50 overflow-hidden">
		<div class="absolute inset-0 bg-ink/40 backdrop-blur-xs transition-opacity" (click)="closeDrawer()"></div>

		<div class="fixed inset-y-0 right-0 max-w-full flex pl-10">
			<div class="w-screen max-w-md bg-surface shadow-pop flex flex-col justify-between border-l border-line">
				<!-- Drawer Header -->
				<div class="px-5 py-4 border-b border-line flex items-center justify-between bg-page">
					<div class="flex items-center gap-2">
						<div class="w-8 h-8 rounded-xl bg-blue-tint text-blue flex items-center justify-center">
							<mat-icon class="!w-4 !h-4 !text-base">tune</mat-icon>
						</div>
						<div>
							<h2 class="item-title text-ink tracking-tight">{{ 'ANALYTICS_FILTER_BAR.ADVANCED_FILTERS' | translate }}</h2>
							<p class="caption text-ink-subtle font-normal">{{ 'ANALYTICS_FILTER_BAR.ADVANCED_FILTERS_DESC' | translate }}</p>
						</div>
					</div>
					<button type="button" (click)="closeDrawer()" class="p-1.5 rounded-lg text-ink-subtle hover:text-ink hover:bg-surface-gray transition-colors">
						<mat-icon class="!w-5 !h-5 !text-xl">close</mat-icon>
					</button>
				</div>

				<!-- Drawer Scrollable Content -->
				<div class="flex-1 overflow-y-auto p-5 space-y-6 text-xs">
					<!-- SECTION 1: BRAND - hidden (2026-11-01): has no effect on the backend request
					     (buildAnalyticsFilterRequest never sends brandRole, and the backend DTO has no
					     such field), so showing it as a selectable filter was misleading - looked like
					     it was narrowing the data when it silently did nothing. FilterState.brandRole,
					     brandRoleOptions, setDraftBrandRole/resetBrandRole stay in the model/Saved
					     Views/URL (a Saved View or link saved before this change still restores a
					     'client'/'competition' value with no error), just never shown or counted as an
					     active filter. -->
					@if (false) {
					<div class="space-y-3 pb-4 border-b border-line">
						<div class="flex items-center justify-between">
							<span class="overline-label text-ink">{{ 'ANALYTICS_FILTER_BAR.SECTION_BRAND_ROLE' | translate }}</span>
							@if (draftFilters.brandRole !== 'all') {
							<button (click)="resetBrandRole()" class="text-[10px] text-blue hover:underline">{{ 'ANALYTICS_FILTER_BAR.RESET' | translate }}</button>
							}
						</div>
						<div class="grid grid-cols-3 gap-1.5">
							@for (role of brandRoleOptions; track role.id) {
							<button
								type="button"
								(click)="setDraftBrandRole(role.id)"
								class="py-2 px-2.5 rounded-xl border text-center font-medium transition-colors text-xs"
								[class]="draftFilters.brandRole === role.id ? 'bg-blue border-blue text-on-blue' : 'bg-surface-gray border-line text-ink-muted hover:bg-neutral-tint'">
								{{ role.label }}
							</button>
							}
						</div>
					</div>
					}

					<!-- SECTION 2: MEDIA -->
					<div class="space-y-4 pb-4 border-b border-line">
						<div class="flex items-center justify-between">
							<span class="overline-label text-ink">{{ 'ANALYTICS_FILTER_BAR.SECTION_MEDIA' | translate }}</span>
							@if (hasMediaSelections()) {
							<button (click)="resetMediaSection()" class="text-[10px] text-blue hover:underline font-medium">{{ 'ANALYTICS_FILTER_BAR.RESET_MEDIA' | translate }}</button>
							}
						</div>

						<div>
							<label class="text-[11px] font-medium text-ink-muted block mb-1.5">{{ 'ANALYTICS_FILTER_BAR.MEDIA_TYPE_MULTISELECT' | translate }}</label>
							<div class="grid grid-cols-2 gap-1.5">
								@for (type of mediaTypeOptions; track type.id) {
								<div
									(click)="toggleDraftMediaType(type.id)"
									class="flex items-center justify-between p-2 rounded-xl border cursor-pointer transition-colors"
									[class]="draftFilters.mediaTypes.includes(type.id) ? 'bg-blue-tint border-blue text-blue font-medium' : 'bg-surface-gray border-line text-ink-muted hover:bg-neutral-tint'">
									<div class="flex items-center gap-2">
										<input type="checkbox" [checked]="draftFilters.mediaTypes.includes(type.id)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
										<mat-icon class="!w-3.5 !h-3.5 !text-sm text-ink-subtle">{{ type.icon }}</mat-icon>
										<span>{{ type.label }}</span>
									</div>
									<span class="text-[9px] font-medium px-1.5 py-0.5 rounded-full shrink-0" [class]="mediaTypeBadgeClasses(type.id)">{{ mediaTypeShortLabel(type.id) }}</span>
								</div>
								}
							</div>
						</div>

						<!-- Media Outlet filter - real outlets from GET /v1/client/analytics/filter-options. -->
						<div class="space-y-1.5">
							<div class="flex items-center justify-between mb-1.5">
								<label class="text-[11px] font-medium text-ink-muted">{{ 'ANALYTICS_FILTER_BAR.MEDIA_OUTLET' | translate }}</label>
								@if (draftFilters.mediaOutlets.length > 0) {
								<span class="text-[10px] text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.N_SELECTED' | translate: { count: draftFilters.mediaOutlets.length } }}</span>
								}
							</div>
							@if (mediaOutletOptions.length === 0) {
							<div class="p-3 rounded-xl border border-line bg-surface-gray text-[11px] text-ink-subtle text-center">
								{{ 'ANALYTICS_FILTER_BAR.NO_MEDIA_OUTLETS' | translate }}
							</div>
							} @else {
							<input
								type="text"
								[(ngModel)]="mediaOutletSearch"
								[placeholder]="'ANALYTICS_FILTER_BAR.SEARCH_OUTLETS_PLACEHOLDER' | translate"
								class="w-full px-2.5 py-1.5 rounded-lg border border-line-strong text-xs focus-visible:outline-2 focus-visible:outline-focus" />
							<div class="max-h-40 overflow-y-auto space-y-1 p-1 bg-surface-gray rounded-lg border border-line">
								@for (outlet of filteredMediaOutlets; track outlet.id) {
								<div
									(click)="toggleDraftMediaOutlet(outlet.id!)"
									class="flex items-center justify-between px-2 py-1 rounded-lg cursor-pointer transition-colors"
									[class]="draftFilters.mediaOutlets.includes(outlet.id!) ? 'bg-blue-tint text-blue font-medium' : 'text-ink-muted hover:bg-neutral-tint'">
									<div class="flex items-center gap-2">
										<input type="checkbox" [checked]="draftFilters.mediaOutlets.includes(outlet.id!)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
										<span>{{ outlet.name }}</span>
									</div>
									<span class="text-[9px] text-ink-subtle">{{ mediumTypeLabel(outlet.type) }}</span>
								</div>
								} @empty {
								<div class="px-2 py-3 text-center text-[11px] text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.NO_OUTLETS_MATCH' | translate: { search: mediaOutletSearch } }}</div>
								}
							</div>
							}
						</div>

						<!-- Author / Journalist filter - cascades from the Media Type/Outlet selection above,
						     same real-data source as Media Outlet. -->
						<div class="space-y-1.5 pt-1">
							<div class="flex items-center justify-between mb-1.5">
								<label class="text-[11px] font-medium text-ink-muted">{{ 'ANALYTICS_FILTER_BAR.AUTHOR_JOURNALIST' | translate }}</label>
								@if (draftFilters.authors.length > 0) {
								<span class="text-[10px] text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.N_SELECTED' | translate: { count: draftFilters.authors.length } }}</span>
								}
							</div>
							@if (authorOptions.length === 0) {
							<div class="p-3 rounded-xl border border-line bg-surface-gray text-[11px] text-ink-subtle text-center">
								{{ 'ANALYTICS_FILTER_BAR.NO_AUTHORS' | translate }}
							</div>
							} @else {
							<input
								type="text"
								[(ngModel)]="authorSearch"
								[placeholder]="'ANALYTICS_FILTER_BAR.SEARCH_AUTHORS_PLACEHOLDER' | translate"
								class="w-full px-2.5 py-1.5 rounded-lg border border-line-strong text-xs focus-visible:outline-2 focus-visible:outline-focus" />
							<div class="max-h-40 overflow-y-auto space-y-1 p-1 bg-surface-gray rounded-lg border border-line">
								@for (author of filteredAuthorOptions; track author.id) {
								<div
									(click)="toggleDraftAuthor(author.id!)"
									class="flex items-center gap-2 px-2 py-1 rounded-lg cursor-pointer transition-colors"
									[class]="draftFilters.authors.includes(author.id!) ? 'bg-blue-tint text-blue font-medium' : 'text-ink-muted hover:bg-neutral-tint'">
									<input type="checkbox" [checked]="draftFilters.authors.includes(author.id!)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
									<span>{{ author.name }}</span>
								</div>
								} @empty {
								<div class="px-2 py-3 text-center text-[11px] text-ink-subtle">
									{{ authorSearch ? ('ANALYTICS_FILTER_BAR.NO_AUTHORS_MATCH' | translate: { search: authorSearch }) : ('ANALYTICS_FILTER_BAR.NO_AUTHORS_FOR_SELECTION' | translate) }}
								</div>
								}
							</div>
							}
						</div>
					</div>

					<!-- SECTION 3: CONTENT -->
					<div class="space-y-4 pb-4 border-b border-line">
						<div class="flex items-center justify-between">
							<span class="overline-label text-ink">{{ 'ANALYTICS_FILTER_BAR.SECTION_CONTENT' | translate }}</span>
							@if (draftFilters.topicGroup !== 'all' || draftFilters.topics.length > 0 || draftFilters.sourceTypes.length > 0) {
							<button (click)="resetContentSection()" class="text-[10px] text-blue hover:underline">{{ 'ANALYTICS_FILTER_BAR.RESET_CONTENT' | translate }}</button>
							}
						</div>

						<div>
							<label class="text-[11px] font-medium text-ink-muted block mb-1.5">{{ 'ANALYTICS_FILTER_BAR.TOPIC_GROUP_LABEL' | translate }}</label>
							<div class="grid grid-cols-3 gap-1.5">
								@for (group of topicGroupOptions; track group.id) {
								<button
									type="button"
									(click)="setDraftTopicGroup(group.id)"
									class="py-1.5 px-2 rounded-xl border text-center font-medium transition-colors text-xs"
									[class]="draftFilters.topicGroup === group.id ? 'bg-blue border-blue text-on-blue' : 'bg-surface-gray border-line text-ink-muted hover:bg-neutral-tint'">
									{{ group.label }}
								</button>
								}
							</div>
						</div>

						<div>
							<div class="flex items-center justify-between mb-1.5">
								<label class="text-[11px] font-medium text-ink-muted">{{ topicCascadeFromLabel }}</label>
								@if (draftFilters.topics.length > 0) {
								<span class="text-[10px] text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.N_SELECTED' | translate: { count: draftFilters.topics.length } }}</span>
								}
							</div>
							<div class="max-h-40 overflow-y-auto space-y-1 p-1 bg-surface-gray rounded-lg border border-line">
								@for (topic of availableTopics; track topic) {
								<div
									(click)="toggleDraftTopic(topic)"
									class="flex items-center justify-between px-2 py-1 rounded-lg cursor-pointer transition-colors"
									[class]="draftFilters.topics.includes(topic) ? 'bg-blue-tint text-blue font-medium' : 'text-ink-muted hover:bg-neutral-tint'">
									<div class="flex items-center gap-2">
										<input type="checkbox" [checked]="draftFilters.topics.includes(topic)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
										<span>{{ translateTopicLabel(topic) }}</span>
									</div>
									<span class="text-[9px] text-ink-subtle">{{ (isIndustryTopic(topic) ? 'ANALYTICS_FILTER_BAR.INDUSTRY' : 'ANALYTICS_FILTER_BAR.CORPORATE') | translate }}</span>
								</div>
								}
							</div>
						</div>

						<div>
							<label class="text-[11px] font-medium text-ink-muted block mb-1.5">{{ 'ANALYTICS_FILTER_BAR.SOURCE_TYPE_LABEL' | translate }}</label>
							<div class="space-y-1">
								@for (source of sourceTypes; track source) {
								<div
									(click)="toggleDraftSourceType(source)"
									class="flex items-center gap-2 px-2 py-1.5 rounded-xl border cursor-pointer transition-colors"
									[class]="draftFilters.sourceTypes.includes(source) ? 'bg-blue-tint border-blue text-blue font-medium' : 'bg-surface-gray border-line text-ink-muted hover:bg-neutral-tint'">
									<input type="checkbox" [checked]="draftFilters.sourceTypes.includes(source)" readonly class="rounded text-blue focus:ring-0 pointer-events-none w-3.5 h-3.5" />
									<span>{{ translateSourceTypeLabel(source) }}</span>
								</div>
								}
							</div>
						</div>
					</div>

					<!-- SECTION 4: TONE (SENTIMENT) -->
					<div class="space-y-3">
						<div class="flex items-center justify-between">
							<span class="overline-label text-ink">{{ 'ANALYTICS_FILTER_BAR.SECTION_SENTIMENT' | translate }}</span>
							@if (draftFilters.sentiments.length > 0) {
							<button (click)="resetSentiments()" class="text-[10px] text-blue hover:underline">{{ 'ANALYTICS_FILTER_BAR.RESET_SENTIMENT' | translate }}</button>
							}
						</div>
						<p class="text-[11px] text-ink-subtle">{{ 'ANALYTICS_FILTER_BAR.SENTIMENT_FILTER_DESC' | translate }}</p>
						<div class="grid grid-cols-3 gap-2">
							@for (s of sentimentOptions; track s.id) {
							<button
								type="button"
								(click)="toggleDraftSentiment(s.id)"
								class="flex flex-col items-center justify-center p-3 rounded-xl border text-center transition-colors"
								[class]="draftFilters.sentiments.includes(s.id)
									? (s.id === 'Positive' ? 'bg-positive border-positive text-on-blue font-medium' : s.id === 'Negative' ? 'bg-negative border-negative text-on-blue font-medium' : 'bg-ink-subtle border-ink-subtle text-on-blue font-medium')
									: 'bg-surface-gray hover:bg-neutral-tint border-line text-ink-muted font-medium'">
								<mat-icon class="!w-4 !h-4 !text-base mb-1">{{ s.icon }}</mat-icon>
								<span class="text-xs">{{ s.label }}</span>
							</button>
							}
						</div>
					</div>
				</div>

				<!-- Drawer Footer -->
				<div class="p-4 border-t border-line bg-page flex items-center justify-between gap-3">
					<button type="button" (click)="clearDrawerFilters()" class="flex items-center gap-1.5 text-ink-muted hover:text-ink font-medium text-xs px-3 h-9 rounded-full hover:bg-surface-gray transition-colors">
						<mat-icon class="!w-3.5 !h-3.5 !text-sm">restart_alt</mat-icon>
						<span>{{ 'ANALYTICS_FILTER_BAR.CLEAR_ALL' | translate }}</span>
					</button>
					<button type="button" (click)="applyDrawerFilters()" class="bg-blue hover:bg-blue-hover text-on-blue font-medium text-xs h-10 px-5 rounded-full transition-colors flex items-center gap-1.5">
						<mat-icon class="!w-3.5 !h-3.5 !text-sm">check</mat-icon>
						<span>{{ 'ANALYTICS_FILTER_BAR.APPLY_FILTERS' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
	}
</div>
